import React from "react";
import { ReactComponent as BackArrowIcon } from "../../../utilities/images/study_dashboard/back_to_learning_arrow.svg";
import "./BackToLearningButton.css";

const BackToLearningButton = ({ onClick }) => (
  <button
    type="button"
    className="back-to-learning-btn"
    aria-label="Back To Learning"
    onClick={onClick}
  >
    <BackArrowIcon className="back-to-learning-btn__icon" aria-hidden="true" />
    <span className="back-to-learning-btn__label">Back To Learning</span>
  </button>
);

export default BackToLearningButton;
